import { ButtonV3, CloseXIcon, TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import Image from '@/app/components/Image';
import Motion from '@/app/components/Motion';

import { useRingAssessmentModalHandlers } from './useRingAssessmentModalHandlers';

const RingAssessmentModal = () => {
  const t = useTranslations();

  const { open, handleOpen, handleClose, userQuizEnabled } =
    useRingAssessmentModalHandlers();

  if (!userQuizEnabled) return null;

  return (
    <>
      <button
        className="fixed bottom-32 right-0 z-50 block origin-bottom-right text-nowrap rounded-t-lg border border-b-0 border-solid border-transparent bg-slate-100 px-6 py-3 text-slate-800 hover:border-sandstone-400 hover:bg-gray-200 hover:shadow-md"
        style={{
          transform: 'rotate(-90deg) translateX(100%)',
        }}
        onClick={handleOpen}
        data-cy="open-assessment-modal-button"
      >
        {t('d2c_quiz_take_quiz')}
      </button>
      <Motion
        initial={{ opacity: 0 }}
        animate={{ opacity: open ? 1 : 0 }}
        className={cx('fixed inset-0 z-200 overflow-hidden duration-300', {
          'pointer-events-auto': open,
          'pointer-events-none': !open,
        })}
        data-cy="ring-assessment-modal"
      >
        <div className="absolute inset-0 z-200 overflow-hidden bg-black opacity-75 backdrop-blur-[10px] duration-300 ease-in-out" />
        <div
          className="absolute inset-0 z-200 flex size-full cursor-default items-center justify-center ease-in-out"
          data-cy="ring-assessment-modal-backdrop"
          onClick={(e) => {
            if (e.target === e.currentTarget) handleClose();
          }}
          onKeyDown={(e) => e.key === 'Escape' && handleClose()}
          role="button"
          tabIndex={-1}
        >
          <div
            className="inset-0 z-200 flex h-full max-h-[600px] w-11/12 max-w-[780px] overflow-hidden overflow-y-auto rounded-[10px] bg-sandstone-200 text-sandstone-500 transition duration-300 ease-in-out md:max-h-[520px] md:w-full"
            role="dialog"
          >
            <Image
              className="hidden flex-1 md:block"
              src="blue-sky/ring-assessment/home-page-modal"
              width={400}
              height={500}
            />
            <div className="relative flex flex-1 flex-col justify-between px-6 pt-12 md:px-8 md:pt-9">
              <button
                className="absolute right-0 top-0 p-4 hover:text-black"
                onClick={handleClose}
                aria-label="Close modal"
                data-cy="close-ring-assessment-modal-button"
              >
                <CloseXIcon />
              </button>
              <TypographyV3
                variant="h2"
                className="hyphens-none text-center text-4xl font-normal leading-10 tracking-wide text-black md:text-left"
              >
                {t.rich('d2c_cta_modal_title')}
              </TypographyV3>
              <div>
                <TypographyV3 className="mb-5 text-center text-xl font-normal md:text-left">
                  {t.rich('d2c_cta_modal_copy')}
                </TypographyV3>
                <ButtonV3
                  variant="outlined-dark"
                  className="mb-8 w-full hover:text-black md:w-fit"
                  href="/ring-assessment"
                  aria-label="Start Quiz"
                  data-cy="start-ring-assessment-button"
                >
                  {t('d2c_start')}
                </ButtonV3>
              </div>
            </div>
          </div>
        </div>
      </Motion>
    </>
  );
};

export default RingAssessmentModal;
